import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Layout from '../../Layout/Layout';
import { Text, Card, Table, Loader, Button } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getVehicles } from '../../actions/vehicleActions';
import moment from 'moment';

const Vehicles = ({ title }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading: vehiclesLoading, vehicles } = useSelector((state) => state.vehicles);


    const openDetailsModalAndGetVehicle = (vehicleId) => {
        navigate(`/vehicle/${vehicleId}`)
    }

    useEffect(() => {
        dispatch(getVehicles())
    }, [dispatch])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title}</title>
            </Helmet>

            <Layout activeKey={6}>
                <Card radius='md' shadow='xl'>
                    <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px' }}>
                        <Text weight={700} size='xl'>Vehicles</Text>
                    </span>
                    {vehiclesLoading ? <Loader color='orange' /> : <Table highlightOnHover>
                        <thead>
                            <tr>
                                <th>Make</th>
                                <th>Model</th>
                                <th>Vehicle No</th>
                                <th>Chassis No</th>
                                <th>Mileage</th>
                                <th>Registered</th>
                                <th>Updated</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {vehicles && vehicles.map((vehicle, key) => {
                                return <tr key={key}>
                                    <td>{vehicle.make}</td>
                                    <td>{vehicle.model}</td>
                                    <td>{vehicle.vehicleNo}</td>
                                    <td>{vehicle.chassisNo}</td>
                                    <td>{vehicle.lastMileage}</td>
                                    <td>{moment(vehicle.createdAt).format('DD-MMM-YYYY HH:mm')}</td>
                                    <td>{moment(vehicle.updatedAt).format('DD-MMM-YYYY HH:mm')}</td>
                                    <td>
                                        <Button onClick={() => openDetailsModalAndGetVehicle(vehicle.uuid)} variant='light' radius='md' fullWidth color='blue'>
                                            Details
                                        </Button>
                                    </td>
                                </tr>
                            })}


                        </tbody>
                    </Table>}

                </Card>

            </Layout>
        </>
    )
}

export default Vehicles
